<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6 11.0711L9.53553 7.53554L6 4.00001" stroke="currentColor" stroke-linecap="round"/>
</svg>
